import * as React from 'react';

const SvgHeaderCompass = (props) => {
	return (
		<svg
			xmlns='http://www.w3.org/2000/svg'
			width='1em'
			height='1em'
			fill='currentColor'
			className='svg-icon'
			viewBox='0 0 16 16'
			{...props}>
			<path d='M8 16.016a7.5 7.5 0 1 0 0-15 7.5 7.5 0 0 0 0 15m3.034-9.881a.5.5 0 0 1 .831.47l-1.713 4.7a.5.5 0 0 1-.292.292l-4.7 1.713a.5.5 0 0 1-.641-.641l1.713-4.7a.5.5 0 0 1 .292-.292zM7.08 8.647l-1.175 3.226 3.226-1.174 1.174-3.227z' />
		</svg>
	);
};

export default SvgHeaderCompass;
